import React from 'react';
import GalleryElement from 'app/components/mediaModule/content/GalleryElement';
import PlaylistElement from 'app/components/mediaModule/content/PlaylistElement';
import EmbeddedVideoElement from 'app/components/mediaModule/content/EmbeddedVideoElement';
import MediaGallery from 'app/components/mediaModule/modules/MediaGallery';
import MediaPlaylist from 'app/components/mediaModule/modules/MediaPlaylist';
import MediaEmbed from 'app/components/mediaModule/modules/MediaEmbed';
export default class MediaComponentFactory {
  static create(media) {
    if (media instanceof MediaGallery) {
      return /*#__PURE__*/React.createElement(GalleryElement, {
        key: media.slug,
        data: media
      });
    } else if (media instanceof MediaPlaylist) {
      return /*#__PURE__*/React.createElement(PlaylistElement, {
        key: media.slug,
        data: media
      });
    } else if (media instanceof MediaEmbed) {
      return /*#__PURE__*/React.createElement(EmbeddedVideoElement, {
        key: media.id,
        data: media
      });
    } else {
      throw new Error("Unknown media type: ".concat(media.mediaType));
    }
  }
}